"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
exports.default = (0, makeStyles_1.default)(function () {
    return (0, core_1.createStyles)({
        inputsContainer: {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            alignItems: 'center',
            columnGap: 16,
            marginBottom: 20,
        },
        textFieldContainer: {
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gridGap: 24,
        },
        addButton: {
            marginLeft: -6,
            marginTop: 8,
        },
    });
});
